import React, { useState, useEffect } from "react";
import Layout from "../components/Layout";
import SEO from "../components/SEO";
import Produto from "../components/Produto";

import { useStaticQuery, graphql } from "gatsby";
import { FaMapMarkerAlt } from "react-icons/fa";
import { AiOutlineMail, AiFillPhone } from "react-icons/ai";
import {
  FiInstagram,
  FiFacebook,
  FiYoutube,
  FiTwitter,
  FiLinkedin,
} from "react-icons/fi";
import MainFeature from "../components/MainFeature";

const Produtos = () => {
  const imgQuery = useStaticQuery(graphql`
    query {
      allFile(filter: { relativeDirectory: { eq: "fotos-ekobe" } }) {
        edges {
          node {
            name
            relativeDirectory
            childImageSharp {
              fluid(maxWidth: 300) {
                ...GatsbyImageSharpFluid_withWebp_tracedSVG
              }
            }
          }
        }
      }
    }
  `);
  const [produtos, setProdutos] = useState(null);
  useEffect(() => {
    setProdutos([
      {
        nome: "K’PSULA CIRCULAPRÓ",
        preco: "77,40",
        categoria: "linha_kpsula",
        foto: "KpsulaCirculapro.png",
      },
      {
        nome: "K’PSULA CARDIO",
        preco: "79,20",
        categoria: "linha_kpsula",
        foto: "KpsulaCardio.png",
      },
      {
        nome: "K’PSULA FIGADPRÓ",
        preco: "69,30",
        categoria: "linha_kpsula",
        foto: "KpsulaFigadpro.png",
      },
      {
        nome: "K’PSULA PARADO®",
        preco: "69,30",
        categoria: "linha_kpsula",
        foto: "KpsulaParador.png",
      },
      {
        nome: "K’PSULA PREBIÓTICA",
        preco: "69,30",
        categoria: "linha_kpsula",
        foto: "KpsulaPrebiotica.png",
      },
      {
        nome: "IMUNESE",
        preco: "59,90",
        categoria: "linha_imunidade",
        foto: "ImuneSe.png",
      },
      {
        nome: "K'PSULA IMUNESE",
        preco: "64,80",
        categoria: "linha_imunidade",
        foto: "KpsulaImuneSe.png",
      },
      {
        nome: "SUPER IMUNESE",
        preco: "49,90",
        categoria: "linha_imunidade",
        foto: "SuperImuneSe-600x400.png",
      },
      {
        nome: "SUPER IMUNESE",
        preco: "49,90",
        categoria: "linha_infantil",
        foto: "SuperImuneSe-600x400.png",
      },
      {
        nome: "ULTRA MEMORY",
        preco: "49,90",
        categoria: "linha_infantil",
        foto: "UltraMemory-600x400.png",
      },
      {
        nome: "MEGA POLIVITAMÍNICO",
        preco: "29,90",
        categoria: "linha_infantil",
        foto: "MegaPolivitaminico-600x400.png",
      },
      {
        nome: "ULTRA CALCÍO",
        preco: "74,90",
        categoria: "linha_infantil",
        foto: "UltraCalcio-600x400.png",
      },
      {
        nome: "SUPER ÔMEGA 3",
        preco: "74,90",
        categoria: "linha_infantil",
        foto: "SuperOmega3-600x400.png",
      },
      {
        nome: "MAGRECHÁ",
        preco: "79,90",
        categoria: "linha_magrecha_inibidores",
        foto: "Magrecha.png",
      },
      {
        nome: "MAGRECHÁ CAPS",
        preco: "79,90",
        categoria: "linha_magrecha_inibidores",
        foto: "MagrechaCaps.png",
      },
      {
        nome: "BE SLIM BLOCK CARB",
        preco: "59,30",
        categoria: "linha_magrecha_inibidores",
        foto: "BeSlimBlockCarb.png",
      },
      {
        nome: "BE SLIM PIMENTA",
        preco: "69,90",
        categoria: "linha_magrecha_inibidores",
        foto: "BeSlimPimenta.png",
      },
      {
        nome: "BE SLIM PITAYA",
        preco: "59,30",
        categoria: "linha_magrecha_inibidores",
        foto: "BeSlimPitaya.png",
      },
      {
        nome: "LOW CARB",
        preco: "79,20",
        categoria: "linha_magrecha_inibidores",
        foto: "LowCarb.png",
      },
      {
        nome: "LOW CARB FRESH",
        preco: "39,60",
        categoria: "linha_magrecha_inibidores",
        foto: "LowCarbFresh.png",
      },
      {
        nome: "VINA MAGRE",
        preco: "35,10",
        categoria: "linha_magrecha_inibidores",
        foto: "VinaMagre.png",
      },
      {
        nome: "Slim Berry",
        preco: "59,40",
        categoria: "linha_magrecha_inibidores",
        foto: "SlimBerry.png",
      },
      {
        nome: "SLIMMER CHROMA",
        preco: "69,90",
        categoria: "linha_magrecha_inibidores",
        foto: "SlimmerChroma.png",
      },
      {
        nome: "SLIMMER + E",
        preco: "59,40",
        categoria: "linha_magrecha_inibidores",
        foto: "SlimmerE.png",
      },
      {
        nome: "SLIMMER FUSION",
        preco: "75,00",
        categoria: "linha_magrecha_inibidores",
        foto: "SlimmerFusion.png",
      },
      {
        nome: "SLIMMER GOLD",
        preco: "89,10",
        categoria: "linha_magrecha_inibidores",
        foto: "SlimmerGold.png",
      },
      {
        nome: "NICOFREE KIT",
        preco: "119,70",
        categoria: "linha_controle_saude",
        foto: "NicoFree.png",
      },
      {
        nome: "NICOFREE SPRAY",
        preco: "59,90",
        categoria: "linha_controle_saude",
        foto: "NicoFreeSpray.png",
      },
      {
        nome: "RENOVE",
        preco: "39,90",
        categoria: "linha_controle_saude",
        foto: "Renove.png",
      },
      {
        nome: "GENGIBRE & ZINCO",
        preco: "39,60",
        categoria: "linha_controle_saude",
        foto: "GengibreZinco.png",
      },
      {
        nome: "FX BLOCK",
        preco: "35,10",
        categoria: "linha_controle_saude",
        foto: "FXblock.png",
      },
      {
        nome: "SPARTE MAG",
        preco: "59,94",
        categoria: "linha_controle_saude",
        foto: "SparteMag.png",
      },
      {
        nome: "NOETHYL",
        preco: "89,90",
        categoria: "linha_controle_saude",
        foto: "Noethyl.png",
      },
      {
        nome: "BE SLIM COLÁGENO",
        preco: "59,30",
        categoria: "linha_nutricosmeticos",
        foto: "BeSlimColageno.png",
      },
      {
        nome: "CELLULIFREE",
        preco: "59,30",
        categoria: "linha_nutricosmeticos",
        foto: "Cellulifree.png",
      },
      {
        nome: "HAIR UP",
        preco: "45,30",
        categoria: "linha_nutricosmeticos",
        foto: "HairUp.png",
      },
      {
        nome: "BE BEAUTY SKIN CARE",
        preco: "69,90",
        categoria: "linha_nutricosmeticos",
        foto: "BeBeautySkinCare.png",
      },
      {
        nome: "NUTRASKIN ANTIOX",
        preco: "69,90",
        categoria: "linha_nutricosmeticos",
        foto: "NutraskinAntiox.png",
      },
      {
        nome: "SKIN BEAUTY HYALURONIC",
        preco: "79,10",
        categoria: "linha_nutricosmeticos",
        foto: "SkinBeautyHyaluronic.png",
      },
      {
        nome: "KOPAYDERM ANTIACNE",
        preco: "59,30",
        categoria: "linha_nutricosmeticos",
        foto: "Kopayderm.png",
      },
      {
        nome: "KOPAYDERM - ÁREAS ULTRA RESSECADAS",
        preco: "69,30",
        categoria: "linha_nutricosmeticos",
        foto: "KopaydermAreasRessecadas.png",
      },
      {
        nome: "KOPAYDERM - CREME PARA MÃOS",
        preco: "59,30",
        categoria: "linha_nutricosmeticos",
        foto: "KopaydermMaos.png",
      },
      {
        nome: "LUZEAX",
        preco: "45,80",
        categoria: "linha_saude_bem_estar",
        foto: "Luzeax.png",
      },
      {
        nome: "QPR BLEND",
        preco: "49,40",
        categoria: "linha_saude_bem_estar",
        foto: "QPRBlend.png",
      },
      {
        nome: "PRÓPOLIVIT",
        preco: "59,40",
        categoria: "linha_saude_bem_estar",
        foto: "PropoliVit.png",
      },
      {
        nome: "VITA GOLD POLIVITAMÍNICO E POLIMINERAL",
        preco: "44,10",
        categoria: "linha_saude_bem_estar",
        foto: "VittaGold.png",
      },
      {
        nome: "OMEGA NUTRIUM",
        preco: "59,30",
        categoria: "linha_saude_bem_estar",
        foto: "OmegaNutrium.png",
      },
      {
        nome: "BE SLIM GLICEM",
        preco: "59,30",
        categoria: "linha_saude_bem_estar",
        foto: "BeSlimGlicem.png",
      },
      {
        nome: "PURE COCO",
        preco: "59,30",
        categoria: "linha_saude_bem_estar",
        foto: "PureCoco.png",
      },
      {
        nome: "PURE CHIA",
        preco: "47,70",
        categoria: "linha_saude_bem_estar",
        foto: "PureChia.png",
      },
      {
        nome: "PURE PERSEA",
        preco: "69,20",
        categoria: "linha_saude_bem_estar",
        foto: "PurePersea.png",
      },
      {
        nome: "K2.D FEMME - MENOPAUSA",
        preco: "47,60",
        categoria: "linha_saude_mulher",
        foto: "K2DFemme.png",
      },
      {
        nome: "CRAN.B",
        preco: "39,60",
        categoria: "linha_saude_mulher",
        foto: "CranB.png",
      },
      {
        nome: "PROFEMINA +E",
        preco: "69,90",
        categoria: "linha_saude_mulher",
        foto: "ProfeminaE.png",
      },
      {
        nome: "K'PSULA ENDOMETRIUM",
        preco: "89,10",
        categoria: "linha_saude_mulher",
        foto: "KpsulaEndometrium.png",
      },
      {
        nome: "FEMME VITAM POLIVITAMÍNICO PARA MULHERES",
        preco: "53,90",
        categoria: "linha_saude_mulher",
        foto: "FemmeVitam.png",
      },
      {
        nome: "GEST VITAM",
        preco: "69,20",
        categoria: "linha_saude_mulher",
        foto: "GestVitam.png",
      },
      {
        nome: "SÊNIOR VITAM",
        preco: "56,33",
        categoria: "linha_saude_homem",
        foto: "SeniorVitam.png",
      },
      {
        nome: "PROSTATVIT",
        preco: "88,20",
        categoria: "linha_saude_homem",
        foto: "ProstatVit.png",
      },
      {
        nome: "BE CALM",
        preco: "59,30",
        categoria: "linha_saude_neural",
        foto: "BeCalm.png",
      },
      {
        nome: "NATURAL SLEEP",
        preco: "59,40",
        categoria: "linha_saude_neural",
        foto: "NaturalSleep.png",
      },
      {
        nome: "NOOTROZYME MEMORY",
        preco: "69,60",
        categoria: "linha_saude_neural",
        foto: "Nootrozyme.png",
      },
      {
        nome: "ÔMEGA 3",
        preco: "69,90",
        categoria: "linha_saude_neural",
        foto: "Omega3.png",
      },
      {
        nome: "BE BEAUTY D TOXX",
        preco: "49,40",
        categoria: "linha_gastrointestinal",
        foto: "BeBeautyDToxx.png",
      },
      {
        nome: "DIGEST MAXX",
        preco: "35,10",
        categoria: "linha_gastrointestinal",
        foto: "DigestMaxx.png",
      },
      {
        nome: "VINA DIGEST",
        preco: "35,10",
        categoria: "linha_gastrointestinal",
        foto: "VinaDigest.png",
      },
      {
        nome: "ALGA CALCIUM",
        preco: "46,80",
        categoria: "linha_saude_ossea",
        foto: "AlgaCalcium.png",
      },
      {
        nome: "ARTROFLEX HYALURONIC",
        preco: "79,20",
        categoria: "linha_saude_ossea",
        foto: "ArtroFlexHyaluronic.png",
      },
      {
        nome: "COLÁGENO ULTRA CONCENTRADO - TIPO II",
        preco: "69,30",
        categoria: "linha_saude_ossea",
        foto: "ColagenoTipoII.png",
      },
      {
        nome: "OSTEO FORCE SUPRAX",
        preco: "49,40",
        categoria: "linha_saude_ossea",
        foto: "OsteoForce.png",
      },
      {
        nome: "MAXX SIZER",
        preco: "69,90",
        categoria: "linha_academia_esportes",
        foto: "MaxxSizer.png",
      },
      {
        nome: "L-CARNITINA",
        preco: "76,40",
        categoria: "linha_academia_esportes",
        foto: "L-Carnitina.png",
      },
      {
        nome: "4 UP",
        preco: "49,40",
        categoria: "linha_academia_esportes",
        foto: "4UP.png",
      },
      {
        nome: "BCAA",
        preco: "69,30",
        categoria: "linha_academia_esportes",
        foto: "BCAA.png",
      },
      {
        nome: "CREATINE",
        preco: "69,20",
        categoria: "linha_academia_esportes",
        foto: "Creatine.png",
      },
      {
        nome: "TURBO BURN",
        preco: "44,10",
        categoria: "linha_academia_esportes",
        foto: "TurboBurn.png",
      },
      {
        nome: "SANDÁLIA TERAPÉ",
        preco: "139,90",
        categoria: "linha_terapeutica",
        foto: "terape.png",
      },
    ]);
  }, []);

  return (
    <Layout>
      <SEO
        title="Produtos"
        description="Compra de produtos Ekobé direta pela sua distribuidora Ekobé Indaiatuba"
      ></SEO>
      <MainFeature></MainFeature>

      <h2 className="uppercase font-bold container mx-auto px-1 bg-teal-400 text-white text-center mt-2 text-2xl">
        PRODUTOS EKOBÉ INDICADOS POR ESPECIALISTAS
      </h2>
      {produtos && (
        <div>
          <h2 className="uppercase font-bold container mx-auto px-1 bg-teal-400 text-white text-center mt-2 text-2xl">
            LINHA K'PSULA
          </h2>
          <div className="container mx-auto">
            <div className="flex flex-wrap justify-center items-center p-4">
              {produtos
                .filter((produto) => produto.categoria === "linha_kpsula")
                .map((produto, index) => {
                  return (
                    <Produto
                      key={index}
                      produto={produto}
                      imgFluid={
                        imgQuery.allFile.edges.filter(
                          (edge) =>
                            edge.node.name === produto.foto.split(".")[0]
                        )[0].node.childImageSharp.fluid
                      }
                    ></Produto>
                  );
                })}
            </div>
          </div>

          <h2 className="uppercase font-bold container mx-auto px-1 bg-teal-400 text-white text-center mt-2 text-2xl">
            LINHA IMUNIDADE
          </h2>
          <div className="container mx-auto">
            <div className="flex flex-wrap justify-center items-center p-4">
              {produtos
                .filter((produto) => produto.categoria === "linha_imunidade")
                .map((produto, index) => {
                  return (
                    <Produto
                      key={index}
                      produto={produto}
                      imgFluid={
                        imgQuery.allFile.edges.filter(
                          (edge) =>
                            edge.node.name === produto.foto.split(".")[0]
                        )[0].node.childImageSharp.fluid
                      }
                    ></Produto>
                  );
                })}
            </div>
          </div>

          <h2 className="uppercase font-bold container mx-auto px-1 bg-teal-400 text-white text-center mt-2 text-2xl">
            LINHA INFANTIL
          </h2>
          <div className="container mx-auto">
            <div className="flex flex-wrap justify-center items-center p-4">
              {produtos
                .filter((produto) => produto.categoria === "linha_infantil")
                .map((produto, index) => {
                  return (
                    <Produto
                      key={index}
                      produto={produto}
                      imgFluid={
                        imgQuery.allFile.edges.filter(
                          (edge) =>
                            edge.node.name === produto.foto.split(".")[0]
                        )[0].node.childImageSharp.fluid
                      }
                    ></Produto>
                  );
                })}
            </div>
          </div>

          <h2 className="uppercase font-bold container mx-auto px-1 bg-teal-400 text-white text-center mt-2 text-2xl">
            LINHA EMAGREÇA COM SAÚDE
          </h2>
          <div className="container mx-auto">
            <div className="flex flex-wrap justify-center items-center p-4">
              {produtos
                .filter(
                  (produto) => produto.categoria === "linha_magrecha_inibidores"
                )
                .map((produto, index) => {
                  return (
                    <Produto
                      key={index}
                      produto={produto}
                      imgFluid={
                        imgQuery.allFile.edges.filter(
                          (edge) =>
                            edge.node.name === produto.foto.split(".")[0]
                        )[0].node.childImageSharp.fluid
                      }
                    ></Produto>
                  );
                })}
            </div>
          </div>

          <h2 className="uppercase font-bold container mx-auto px-1 bg-teal-400 text-white text-center mt-2 text-2xl">
            LINHA CONTROLE SAÚDE
          </h2>
          <div className="container mx-auto">
            <div className="flex flex-wrap justify-center items-center p-4">
              {produtos
                .filter(
                  (produto) => produto.categoria === "linha_controle_saude"
                )
                .map((produto, index) => {
                  return (
                    <Produto
                      key={index}
                      produto={produto}
                      imgFluid={
                        imgQuery.allFile.edges.filter(
                          (edge) =>
                            edge.node.name === produto.foto.split(".")[0]
                        )[0].node.childImageSharp.fluid
                      }
                    ></Produto>
                  );
                })}
            </div>
          </div>

          <h2 className="uppercase font-bold container mx-auto px-1 bg-teal-400 text-white text-center mt-2 text-2xl">
            LINHA NUTRICOSMÉTICOS
          </h2>
          <div className="container mx-auto">
            <div className="flex flex-wrap justify-center items-center p-4">
              {produtos
                .filter(
                  (produto) => produto.categoria === "linha_nutricosmeticos"
                )
                .map((produto, index) => {
                  return (
                    <Produto
                      key={index}
                      produto={produto}
                      imgFluid={
                        imgQuery.allFile.edges.filter(
                          (edge) =>
                            edge.node.name === produto.foto.split(".")[0]
                        )[0].node.childImageSharp.fluid
                      }
                    ></Produto>
                  );
                })}
            </div>
          </div>

          <h2 className="uppercase font-bold container mx-auto px-1 bg-teal-400 text-white text-center mt-2 text-2xl">
            LINHA SAÚDE E BEM ESTAR
          </h2>
          <div className="container mx-auto">
            <div className="flex flex-wrap justify-center items-center p-4">
              {produtos
                .filter(
                  (produto) => produto.categoria === "linha_saude_bem_estar"
                )
                .map((produto, index) => {
                  return (
                    <Produto
                      key={index}
                      produto={produto}
                      imgFluid={
                        imgQuery.allFile.edges.filter(
                          (edge) =>
                            edge.node.name === produto.foto.split(".")[0]
                        )[0].node.childImageSharp.fluid
                      }
                    ></Produto>
                  );
                })}
            </div>
          </div>

          <h2 className="uppercase font-bold container mx-auto px-1 bg-teal-400 text-white text-center mt-2 text-2xl">
            LINHA SAÚDE DA MULHER
          </h2>
          <div className="container mx-auto">
            <div className="flex flex-wrap justify-center items-center p-4">
              {produtos
                .filter((produto) => produto.categoria === "linha_saude_mulher")
                .map((produto, index) => {
                  return (
                    <Produto
                      key={index}
                      produto={produto}
                      imgFluid={
                        imgQuery.allFile.edges.filter(
                          (edge) =>
                            edge.node.name === produto.foto.split(".")[0]
                        )[0].node.childImageSharp.fluid
                      }
                    ></Produto>
                  );
                })}
            </div>
          </div>

          <h2 className="uppercase font-bold container mx-auto px-1 bg-teal-400 text-white text-center mt-2 text-2xl">
            LINHA SAÚDE DO HOMEM
          </h2>
          <div className="container mx-auto">
            <div className="flex flex-wrap justify-center items-center p-4">
              {produtos
                .filter((produto) => produto.categoria === "linha_saude_homem")
                .map((produto, index) => {
                  return (
                    <Produto
                      key={index}
                      produto={produto}
                      imgFluid={
                        imgQuery.allFile.edges.filter(
                          (edge) =>
                            edge.node.name === produto.foto.split(".")[0]
                        )[0].node.childImageSharp.fluid
                      }
                    ></Produto>
                  );
                })}
            </div>
          </div>

          <h2 className="uppercase font-bold container mx-auto px-1 bg-teal-400 text-white text-center mt-2 text-2xl">
            LINHA NEURAL
          </h2>
          <div className="container mx-auto">
            <div className="flex flex-wrap justify-center items-center p-4">
              {produtos
                .filter((produto) => produto.categoria === "linha_saude_neural")
                .map((produto, index) => {
                  return (
                    <Produto
                      key={index}
                      produto={produto}
                      imgFluid={
                        imgQuery.allFile.edges.filter(
                          (edge) =>
                            edge.node.name === produto.foto.split(".")[0]
                        )[0].node.childImageSharp.fluid
                      }
                    ></Produto>
                  );
                })}
            </div>
          </div>

          <h2 className="uppercase font-bold container mx-auto px-1 bg-teal-400 text-white text-center mt-2 text-2xl">
            LINHA SAÚDE GASTROINTESTINAL
          </h2>
          <div className="container mx-auto">
            <div className="flex flex-wrap justify-center items-center p-4">
              {produtos
                .filter(
                  (produto) => produto.categoria === "linha_gastrointestinal"
                )
                .map((produto, index) => {
                  return (
                    <Produto
                      key={index}
                      produto={produto}
                      imgFluid={
                        imgQuery.allFile.edges.filter(
                          (edge) =>
                            edge.node.name === produto.foto.split(".")[0]
                        )[0].node.childImageSharp.fluid
                      }
                    ></Produto>
                  );
                })}
            </div>
          </div>

          <h2 className="uppercase font-bold container mx-auto px-1 bg-teal-400 text-white text-center mt-2 text-2xl">
            LINHA SAÚDE ÓSSEA
          </h2>
          <div className="container mx-auto">
            <div className="flex flex-wrap justify-center items-center p-4">
              {produtos
                .filter((produto) => produto.categoria === "linha_saude_ossea")
                .map((produto, index) => {
                  return (
                    <Produto
                      key={index}
                      produto={produto}
                      imgFluid={
                        imgQuery.allFile.edges.filter(
                          (edge) =>
                            edge.node.name === produto.foto.split(".")[0]
                        )[0].node.childImageSharp.fluid
                      }
                    ></Produto>
                  );
                })}
            </div>
          </div>

          <h2 className="uppercase font-bold container mx-auto px-1 bg-teal-400 text-white text-center mt-2 text-2xl">
            LINHA ACADEMIA E ESPORTES
          </h2>
          <div className="container mx-auto">
            <div className="flex flex-wrap justify-center items-center p-4">
              {produtos
                .filter(
                  (produto) => produto.categoria === "linha_academia_esportes"
                )
                .map((produto, index) => {
                  return (
                    <Produto
                      key={index}
                      produto={produto}
                      imgFluid={
                        imgQuery.allFile.edges.filter(
                          (edge) =>
                            edge.node.name === produto.foto.split(".")[0]
                        )[0].node.childImageSharp.fluid
                      }
                    ></Produto>
                  );
                })}
            </div>
          </div>

          <h2 className="uppercase font-bold container mx-auto px-1 bg-teal-400 text-white text-center mt-2 text-2xl">
            LINHA TERAPÊUTICA
          </h2>
          <div className="container mx-auto">
            <div className="flex flex-wrap justify-center items-center p-4">
              {produtos
                .filter((produto) => produto.categoria === "linha_terapeutica")
                .map((produto, index) => {
                  return (
                    <Produto
                      key={index}
                      produto={produto}
                      imgFluid={
                        imgQuery.allFile.edges.filter(
                          (edge) =>
                            edge.node.name === produto.foto.split(".")[0]
                        )[0].node.childImageSharp.fluid
                      }
                    ></Produto>
                  );
                })}
            </div>
          </div>
        </div>
      )}
      <div className="bg-teal-400 h-6 mt-2"></div>
      <div className="bg-teal-500 ">
        <div className="container mx-auto px-1 py-4 flex flex-wrap items-center justify-center">
          <div className="text-center w-full md:w-1/2 flex flex-col justify-center items-center">
            <h3 className="font-bold text-white text-2xl mb-4">Informações</h3>
            <div className="text-lg text-left">
              <div>
                <FaMapMarkerAlt className="inline  text-white"></FaMapMarkerAlt>
                <h3 className="ml-2 inline mt-2 text-white ">
                  Rua Zephiro Puccinelli, 593 - Indaiatuba/SP
                </h3>
              </div>
              <div>
                <AiFillPhone className="inline  text-white"></AiFillPhone>

                <h3 className="ml-2 inline mt-2 text-white ">
                  (19) 99382-0824
                </h3>
              </div>

              <div>
                <AiOutlineMail className="inline  text-white"></AiOutlineMail>
                <h3 className="ml-2 inline mt-2 text-white ">
                  contato@ekobeindaiatuba.com.br
                </h3>
              </div>
            </div>
          </div>
          <div className="text-center w-full md:w-1/2 flex flex-col justify-center items-center">
            <h3 className="font-bold mt-2 text-white text-2xl mb-4">
              Conheça Nosso Trabalho
            </h3>
            <div className="flex text-white text-4xl">
              <a
                rel="noopener noreferrer"
                target="_blank"
                href="https://facebook.com/EkobeOficial"
              >
                <FiFacebook className="mr-4"></FiFacebook>
              </a>
              <a
                rel="noopener noreferrer"
                target="_blank"
                href="https://instagram.com/EkobeOficial"
              >
                <FiInstagram className="mr-4"></FiInstagram>
              </a>
              <a
                rel="noopener noreferrer"
                target="_blank"
                href="https://linkedin.com/company/EkobeOficial"
              >
                <FiLinkedin className="mr-4"></FiLinkedin>
              </a>
              <a
                rel="noopener noreferrer"
                target="_blank"
                href="https://twitter.com/EkobeOficial"
              >
                <FiTwitter className="mr-4"></FiTwitter>
              </a>
              <a
                rel="noopener noreferrer"
                target="_blank"
                href="https://www.youtube.com/EkobeOficial"
              >
                <FiYoutube className="mr-4"></FiYoutube>
              </a>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Produtos;
